import React, { useEffect } from 'react';
import { Main } from '@components/Main';
import { BrandingContainer } from '@components/Branding';
import { withTrans } from '@i18n/withTrans';

const Branding = ({ i18n, pageContext }) => {
  
  useEffect(() => {
    i18n.changeLanguage(pageContext.lang)
  }, [i18n, pageContext])
  
  return (
    <Main pageContext={pageContext}>
      <BrandingContainer/>
    </Main>
  )
}

const BrandingPage = withTrans(Branding);

export default BrandingPage 
